import axios from "axios";
import store from "@/store/index.js";

const baseUrl = process.env.VUE_APP_API_URL_WINDROW_REGISTRATION;
const appError = {
  applicationError: {
    hasError: true,
    error:
      " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
  }
};

const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

httpClient.interceptors.response.use(
  response => response,
  error => errorInterceptor(error)
);

const errorInterceptor = error => {
  if (error && !error.response) {
    if (error.code === "ECONNABORTED") {
      error.response = {
        data: {
          isSucess: false,
          errors: {
            Files: [
              "The server request or connection has timed out, and it happens mostly if your internet connection is unresponsive or slow. Please try again in sometime and if issue persists then call our support team."
            ]
          }
        }
      };
    }
  }
  return Promise.reject(error);
};
export default {
  healthCheck() {
    return httpClient.get(baseUrl);
  },
  postWindrowRegistrationInfo(windrowRegistrationInfo) {
    return httpClient.post(baseUrl + "Register", windrowRegistrationInfo);
  },
  uploadDocuments(filesUploadInfo) {
    return httpClient.post(baseUrl + "FileUpload", filesUploadInfo, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  }
};
